// @flow

import actionCreators from "@modules/reporting/actionCreator";
import { all, call, put, takeEvery } from "redux-saga/effects";
import type { Action } from "redux-action";
import { CreateAbsenceTrendsReport } from "@modules/reporting/constants/actions";
import http from "@http";
import type { AbsenceTrendsReportItem } from "../../reducer/first-care-index/types";

type ManagerRequest = $Exact<{
  clientId: number,
  filters: Object,
}>;

export function* onCreateAbsenceTrendsReport({
  payload,
}: Action<ManagerRequest>): Generator<*, void, { data: AbsenceTrendsReportItem[] }> {
  if (!payload || !payload.clientId) {
    throw Error(`Invalid payload provided:\n\n${JSON.stringify(payload, null, 2)}\n\n`);
  }
  try {
    const response = yield call(
      http.post,
      `/api/v1/tools/client/${payload.clientId}/tools/absence/trends`,
      payload.filters,
    );

    yield put(actionCreators.CreateAbsenceTrendsReportSuccess(response.data));
  } catch (e) {
    yield put(actionCreators.CreateAbsenceTrendsReportError(e.response));
  }
}

export function* FirstCareIndexSaga(): Generator<*, void, void> {
  yield all([takeEvery(CreateAbsenceTrendsReport, onCreateAbsenceTrendsReport)]);
}

export default FirstCareIndexSaga;
